import * as ACTION from '../constants/types/baseTypes'
import WINNER_MP3 from '../media/audio/prize.mp3'
import WINNER_WAV from '../media/audio/prize.wav'
import COUNTDOWN_MP3 from '../media/audio/ring.mp3'
import COUNTDOWN_WAV from '../media/audio/ring.wav'
import { packageReq } from '../helpers/request'

// 测试使用1111
export function sayHello() {
  return {type: ACTION.SAY_HELLO}
}

// 打开loading遮罩
export function openLoading(text = '') {
  return {
    type: ACTION.LOADING_OPEN,
    text: text
  }
}

// 关闭loading遮罩
export function closeLoading() {
  return {type: ACTION.LOADING_CLOSE}
}

// 打开遮罩
export function openOverlay() {
  return {type: ACTION.OVERLAY_OPEN}
}

// 关闭遮罩
export function closeOverlay() {
  return {type: ACTION.OVERLAY_CLOSE}
}

// 打开手机版左右侧菜单
export function openNavigator() {
  return {type: ACTION.NAVIGATOR_OPEN}
}

// 关闭手机版左右侧菜单
export function closeNavigator() {
  return {type: ACTION.NAVIGATOR_CLOSE}
}

/**
 * 弹出alert
 * @param  {[type]}   text       [内容]
 * @param  {Function} callback   [回调函数]
 * @param  {[number]} delay      [延时自动执行秒数]
 * @param  {String}   title      [标题]
 * @param  {String}   buttonText [按钮文字]
 * @author: ammo
 */
export function openAlert(text, callback = null, delay = null, title = 'prompt', buttonText = 'confirm', params = null) {
  return {
    type: ACTION.ALERT_OPEN,
    options: {
      text: text,
      callback: callback,
      delay: delay,
      title: title,
      buttonText: buttonText,
      params: params
    }
  }
}

// 关闭弹出框
export function closeAlert() {
  return {
    type: ACTION.ALERT_CLOSE
  }
}

/**
 * 打开确认框
 * @param  {[type]} text    [内容]
 * @param  {[type]} confirm [确定按钮回调函数]
 * @param  {[type]} cancel  [取消按钮回调函数]
 * @param  {String} title   [标题]
 * @return {[type]}         [description]
 */
export function openConfirm(text, confirm, cancel, title = '提示', params = null, extendButtons = null, className,confirmBtnText) {
  return {
    type: ACTION.CONFIRM_OPEN,
    options: {
      text: text,
      confirm: confirm,
      cancel: cancel,
      title: title,
      params: params,
      className: className,
      extendButtons: extendButtons,
      confirmBtnText: confirmBtnText
    }
  }
}

// 关闭确认框
export function closeConfirm() {
  return {
    type: ACTION.CONFIRM_CLOSE
  }
}

/**
 * 服务层切换路由
 * @param  {[type]}  uri    [切换的URI地址]
 * @param  {Boolean} isPrev [是否回到上一次路由地址]
 * @author: ammo
 */
export function changeRouter(uri, isPrev = false) {
  return {
    type: ACTION.ROUTER_CHANGE,
    options: {
      uri: uri,
      isPrev: isPrev
    }
  }
}


// 生成随机数
export function randomMaker() {
  return {
    type: ACTION.RANDOM_MAKER
  }
}

//换肤
export function switchSkin(className) {
  return {
    type: ACTION.SKINNING,
    options: {
      skin: className
    }
  }
}

// 音频中奖啦！！ - -||
export function winnerSound() {
  return {
    type: ACTION.PLAY_SOUND,
    options: {
      play: true,
      mp3: WINNER_MP3,
      wav: WINNER_WAV,
      times: 1,
      stopFn: closeSound
    }
  }
}

// 投注10秒倒计时
export function countDown() {
  return {
    type: ACTION.PLAY_SOUND,
    options: {
      play: true,
      mp3: COUNTDOWN_MP3,
      wav: COUNTDOWN_WAV,
      times: _.random(9999999),
      stopFn: closeSound
    }
  }
}

// 关闭声音
export function closeSound() {
  return {
    type: ACTION.STOP_SOUND
  }
}

// 关闭拖拽IFRAME
export function closeDragFrame() {
  return {
    type: ACTION.CLOSE_DRAG_FRAME
  }
}

// 打开拖拽IFRAME
export function openDragFrame(url) {
  return {
    type: ACTION.OPEN_DRAG_FRAME,
    url: url
  }
}

// 打开小提示
export function openToast(message, className) {
  return {
    type: ACTION.OPEN_TOAST,
    message: message,
    className: className
  }
}

// 关闭小提示
export function closeToast() {
  return {
    type: ACTION.CLOSE_TOAST
  }
}

// 开启中奖通知
export function startWinnerNotice() {
  return {
    type: ACTION.START_WINNER_NOTICE
  }
}


// 关闭中奖通知
export function stopWinnerNotice() {
  return {
    type: ACTION.STOP_WINNER_NOTICE
  }
}

// 开启声音通知提示
export function startSoundNotice() {
  return {
    type: ACTION.START_SOUND_NOTICE
  }
}


// 关闭声音通知提示
export function stopSoundNotice() {
  return {
    type: ACTION.STOP_SOUND_NOTICE
  }
}

// 开启显示余额
export function showBalance() {
  return {
    type: ACTION.SHOW_BALANCE
  }
}

// 关闭显示余额
export function hideBalance() {
  return {
    type: ACTION.HIDE_BALANCE
  }
}

// 显示界面
export function showUI(delay = 0) {
  return {
    type: ACTION.SHOW_UI,
    delayAction: delay
  }
}

// 帮助其他action执行
export function excuter(obj) {
  if (obj && obj.type) {
    return obj
  }
  return {type: 'TO_DO_NOTHING'}
}

// 打开关闭动画
export function toggleDisplayAnimation(status) {
  return {
    type: ACTION.TOGGLE_DISPLAY_ANIMATION,
    status: status
  }
}

/**
 * 打开嵌套IFRAME MODAL
 * @param  {[type]} url    [description]
 * @param  {[type]} text   [description]
 * @param  {[type]} width  [description]
 * @param  {[type]} height [description]
 * @return {[type]}        [description]
 */
export function openIframeModal(url, text, width, height) {
  return {
    type: ACTION.IFRAME_MODAL_OPEN,
    options: {
      url: url,
      text: text,
      width: width,
      height: height
    }
  }
}

/**
 * 关闭嵌套IFRAME MODAL
 * @return {[type]} [description]
 */
export function closeIframeModal() {
  return {
    type: ACTION.IFRAME_MODAL_CLOSE
  }
}

// 打开转账弹窗
export function openTransferModal(platform, url) {
  return {
    type: ACTION.TRANSFER_MODAL_OPEN,
    options: {
      platform: platform,
      url: url
    }

  }
}

// 获取广告合集
export function getAds() {

	var payload = packageReq('GET_ADS', null, null, 'GET')

	return {
		type: ACTION.ADS_RECOMMEND,
  	payload
	}
}

// 关闭转账弹窗
export function closeTransferModal() {
  return {
    type: ACTION.TRANSFER_MODAL_CLOSE,
  }
}

